import { watchDeleteWarehouseUser } from './deleteWarehouseUser';
import { watchFetchWarehousePermissions } from './fetchWarehousePermissions';
import { watchUpdateWarehouseUser } from './updateWarehouseUser';

export const warehousePermissionsSagas = [
  watchFetchWarehousePermissions(),
  watchDeleteWarehouseUser(),
  watchUpdateWarehouseUser()
];
export const warehousePermissionUrl = ({ departmentId, sid }: { departmentId: number; sid?: string }) =>
  `/WarehousePermissions/${departmentId}/Users${sid ? `/${sid}` : ''}`;
